import React from 'react';
import { getCurrency } from "../config/utils";
import { dateIso2Us } from "../config/dateUtils";
import { useSxStyles } from "../styles/sxStyles";
import Grid2 from '@mui/material/Grid2';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

const InstallmentList = (props) => {
    const installments = props.installments;
    const classes = useSxStyles;

    return (<>
        <List sx={{...classes.list, maxHeight: '100%'}} >
            <ListItem alignItems='flex-start' disableGutters sx={classes.listPadding}>
                <ListItemText
                    sx={classes.listText}
                    primary={
                        <Grid2
                            container
                            spacing={1}
                            alignItems="top"
                        >
                            <Grid2 size={3}>Select</Grid2>
                            <Grid2 size={2} >No.</Grid2>
                            <Grid2 size={4} >Due Date</Grid2>
                            <Grid2 style={{paddingLeft: '1rem'}} size={3}>Amount</Grid2>
                        </Grid2>
                    }
                    slotProps={{
                        primary: {
                            component: 'span',
                            color: 'textPrimary',
                            sx: {fontSize: '.9rem', lineHeight: '.7rem'},
                        }
                    }}
                />
            </ListItem>
            {installments && installments.length > 0 && installments.map((installment) => {
                return (
                    (<ListItem alignItems='flex-start' disableGutters sx={classes.listPadding}>
                        <ListItemText
                            sx={classes.listText}
                            primary={
                                <Grid2
                                    container
                                    spacing={1}
                                    alignItems="top"
                                >
                                    <Grid2 size={3}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    name="pay"
                                                    color='primary'
                                                    sx={{paddingLeft: '.5rem', paddingBottom: '1rem'}}
                                                    defaultChecked={false}
                                                    onChange={(e) => {installment.checked = e.target.checked}}
                                                />
                                            }
                                            label=''
                                            sx={{...classes.checkbox, paddingLeft: '0'}}
                                        />
                                    </Grid2>
                                    <Grid2 size={2}>{`${installment.priorityOrder}`}</Grid2>
                                    <Grid2 size={4}>{dateIso2Us(installment.dueDate)}</Grid2>
                                    <Grid2 style={{paddingLeft: '1rem'}} size={3}>{getCurrency(installment.installmentAmount)}</Grid2>
                                </Grid2>
                            }
                            slotProps={{
                                primary: {
                                    component: 'span',
                                    color: 'textPrimary',
                                    sx: {fontSize: '.9rem', lineHeight: '.5rem'}
                                }
                            }}
                        />
                    </ListItem>)
                );
            })}
        </List>
    </>);
}

export default InstallmentList;
